import axios from "axios";
import { API_URL } from "../../../setup/config/env";

export const fetchRoles = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/roles`);
        return Array.isArray(response.data.data) ? response.data.data : [];
    } catch (error) {
        console.error("Error fetching roles:", error);
        throw error;
    }
};

export const fetchRoleById = async (roleId) => {
    try {
        const response = await axios.get(`${API_URL}/api/roles/${roleId}`);
        return response.data.data;
    } catch (error) {
        console.error("Error fetching role by ID:", error);
        throw error;
    }
};
export const getFeatureProfileUrls = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/settings?profile=features`);
        return response.data.data;
    }
    catch (error) {
        console.error("Error fetching feature profile URLs:", error);
        throw error;
    }
};